<script lang="typescript">
import type { Meeting } from "../../common/types";
import { isWpSuccess, wpFetchRestApi } from "../../util";


  export let meeting:Meeting;
  let time:string;

  const save = async () => {
    const endpoint = 'meeting/' + meeting.id + '/time/';
    const result = await wpFetchRestApi<Meeting>(endpoint, 'POST', {time});
    if (isWpSuccess(result)) {
      return result.data;
    }
    throw new Error(result.message);
  };


</script>

<div>
    <h3>{meeting.title}</h3>
    <form on:submit|preventDefault={save}>
      <p>
      <label for="time">
        Aika
      </label>
      <input bind:value={time} type="time" id="time" name="time">
      </p>
      <p>
      <input type="submit" value="Tallenna">
      </p>
    </form>
</div>

<style>
</style>

